var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackArrowBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.18459 9.99982L9.71729 17.5325C9.91601 17.7312 10.0128 17.9652 10.0077 18.2344C10.0025 18.5037 9.90061 18.7376 9.70189 18.9363C9.50319 19.1351 9.26922 19.2344 8.99999 19.2344C8.73075 19.2344 8.49679 19.1351 8.29809 18.9363L0.626939 11.2806C0.446155 11.0998 0.31218 10.8972 0.225014 10.6729C0.13783 10.4485 0.0942383 10.2242 0.0942383 9.99982C0.0942383 9.77547 0.13783 9.55111 0.225014 9.32674C0.31218 9.10239 0.446155 8.89984 0.626939 8.71907L8.29809 1.04792C8.49679 0.849201 8.73332 0.7524 9.00769 0.757517C9.28204 0.76265 9.51857 0.864576 9.71729 1.06329C9.91601 1.26201 10.0154 1.49598 10.0154 1.76519C10.0154 2.03443 9.91601 2.2684 9.71729 2.46712L2.18459 9.99982Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackArrowBackIcon);
export default __webpack_public_path__ + "static/media/black-arrow-back-icon.39840bd9868a571cc9bba17886241411.svg";
export { ForwardRef as ReactComponent };